<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.96753 6.63184V5.88184M9.96753 13.3818V14.1318M11.5917 7.75684C11.2675 7.30849 10.6616 7.00684 9.96753 7.00684H9.75918C8.8387 7.00684 8.09253 7.60379 8.09253 8.34017V8.39741C8.09253 8.92414 8.46451 9.40564 9.05343 9.64121L10.8816 10.3725C11.4705 10.608 11.8425 11.0895 11.8425 11.6163C11.8425 12.3843 11.0643 13.0068 10.1043 13.0068H9.96753C9.27348 13.0068 8.66755 12.7052 8.34337 12.2568M16.7175 10.0068C16.7175 13.7348 13.6955 16.7568 9.96753 16.7568C6.23961 16.7568 3.21753 13.7348 3.21753 10.0068C3.21753 6.27892 6.23961 3.25684 9.96753 3.25684C13.6955 3.25684 16.7175 6.27892 16.7175 10.0068Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'MoneyCircleIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
